import { ReactComponent as Download } from 'assett/icons/download_arrow_slim.svg';
import useDevice from 'hooks/DesktopDevice.hook';
import { useFileOpener } from 'hooks/downloader.hook';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Button, Stack } from 'styles';
import CompositeTypography from 'styles/typography/CompositeTypography.styles';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const ClaimReturnDetails = () => {
	const { claimData: claim } = useSelector((store: RootState) => store.claim);
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});

	const { isDesktop } = useDevice();

	const fileOpener = useFileOpener();

	const handleClickDownload = () => {
		const url = `${process.env.REACT_APP_API_URL}/attachments/return/${claim?.returnDetail?.attachmentUuid}/content`;
		fileOpener({ url, fileName: claim?.returnDetail?.attachmentName });
	};

	return (
		<>
			<Stack
				flexDirection={isDesktop ? 'row' : 'column'}
				justifyContent={'space-between'}
				alignItems={isDesktop ? 'center' : 'flex-start'}
				gap={'15px'}
			>
				<CompositeTypography
					label={tClientLabels('claim.labels.returnStatus')}
					value={tDbLabels(claim?.returnDetail?.statusLabel as string)}
				/>
				<Button
					startIcon={<Download width={14} height={14} />}
					variant="text"
					onClick={handleClickDownload}
					sx={{
						p: 0,
						textDecoration: 'underline',
						gap: '8px',
						'&:hover': {
							textDecoration: 'underline',
						},
					}}
				>
					{tClientLabels('claim.return.download')}
				</Button>
			</Stack>
			<CompositeTypography
				label={tClientLabels('claim.labels.returnReasonCode')}
				value={tDbLabels(claim?.returnDetail?.reasonCodeLabel as string)}
				notBold
			/>
		</>
	);
};

export default ClaimReturnDetails;
